module.exports = __webpack_public_path__ + "static/scale-model-of-scene75-entertainment-center-|-dayton-in-dayton-ohio-7933760f662cb5fa8fdb1e8dbf90c917.png";